import React from "react";
import { Star, StarFill } from "react-bootstrap-icons";
import { empty } from "../../../common/functions";

interface IDemandFile {
  setRate?: React.Dispatch<React.SetStateAction<number>>;
  rate: number | null;
  max: number;
  readonly: boolean;
  add2class: string;
}

export const DemandRate = ({
  rate,
  max,
  setRate = undefined,
  readonly,
  add2class = "div-dem-rate",
}: IDemandFile) => {
  //console.log("rate:", rate, max)
  const rates = Array(max).fill(1);
  const onClick = (i: any) => {
    if (!readonly && setRate != undefined ) setRate(i);
  };
  let isRateEmpty = rate === 0;
  if (isRateEmpty && readonly) return <></>;
  return (
    <div className={add2class}>
      {rates.map((r, i) => (
        <div
          key={i}
          className="text-warning pl-1 pr-1 cp"
          onClick={() => onClick(i + 1)}
        >
          {isRateEmpty || rate == null || i >= rate ? <Star /> : <StarFill /> }
        </div>
      ))}
    </div>
  );
};
